import React from 'react'
import { Pagination as MuiPagination, PaginationItem } from '@mui/material'
import PropTypes from 'prop-types'

export default function Pagination(props) {
  const { items, limit = 20 } = props

  return (
    <MuiPagination
      count={Math.round((items || 1) / limit + 1)}
      variant='outlined'
      shape='rounded'
      renderItem={(item) => (
        <PaginationItem
          sx={{
            root: {
              backgroundColor: '#fff',
              borderColor: '#0015C4',
              color: '#0015C4'
            },
            selected: {
              borderColor: '#0015C4',
              borderWidth: '2px',
              color: '#0015C4'
            }
          }}
          {...item}
        />
      )}
    />
  )
}

Pagination.propTypes = {
  items: PropTypes.number,
  limit: PropTypes.number
}
